const VerticalLayout = () => import('@/layouts/VerticalLayout')

const customers = () => import('./views/index')
const accountsList = () => import('./views/accounts/list')

const accountsDetails = () => import('./views/accounts/details')

const purchasesSection = () => import('./views/sections/purchases')
const giftsSection = () => import('./views/sections/gifts')
const servicesSection = () => import('./views/sections/services')

const purchasesCurrent = () => import('./views/purchases/current.vue')
const purchasesHistory = () => import('./views/purchases/history.vue')
const giftsCurrent = () => import('./views/gifts/current.vue')
const giftsHistory = () => import('./views/gifts/history.vue')

const activity = () => import('./views/activity')

export default [
  {
    path: '/business/customers',
    name: 'BusinessCustomers',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'BusinessCustomers',
      component: customers,
      redirect: { name: 'customers.activity' },
      meta: { name: 'customers', userType: 'provider', serviceTypes: 'all' },
      children: [
        {
          path: 'accounts',
          name: 'customers.accounts',
          component: accountsList,
          meta: { name: 'accounts', userType: 'provider', serviceTypes: 'all' }
        },
        {
          path: 'activity',
          name: 'customers.activity',
          component: activity,
          redirect: { name: 'customers.activity.purchases' },
          meta: { name: 'activity', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'purchases',
              name: 'customers.activity.purchases',
              component: purchasesSection,
              redirect: { name: 'customers.activity.purchases.current' },
              meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all' },
              children: [
                {
                  path: 'current',
                  name: 'customers.activity.purchases.current',
                  component: purchasesCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
                },
                {
                  path: 'history',
                  name: 'customers.activity.purchases.history',
                  component: purchasesHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
                }
              ]
            },
            {
              path: 'gifts',
              name: 'customers.activity.gifts',
              component: giftsSection,
              redirect: { name: 'customers.activity.gifts.current' },
              meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all' },
              children: [
                {
                  path: 'current',
                  name: 'customers.activity.gifts.current',
                  component: giftsCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
                },
                {
                  path: 'history',
                  name: 'customers.activity.gifts.history',
                  component: giftsHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
                }
              ]
            },
            {
              path: 'services',
              name: 'customers.activity.services',
              component: servicesSection,
              meta: { name: 'services', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        }
      ]
    },
    {
      path: 'account',
      name: 'customers.accountsDetails',
      component: accountsDetails,
      redirect: to => ({ name: 'customers.accountsDetails.purchases', params: to.params }),
      meta: { name: 'accountsDetails', userType: 'provider', serviceTypes: 'all' },
      children: [
        {
          path: 'purchases/:id?',
          name: 'customers.accountsDetails.purchases',
          component: purchasesSection,
          redirect: to => ({ name: 'customers.accountsDetails.purchases.current', params: to.params }),
          meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.purchases.current',
              component: purchasesCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.purchases.history',
              component: purchasesHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        },
        {
          path: 'gifts/:id?',
          name: 'customers.accountsDetails.gifts',
          component: giftsSection,
          redirect: to => ({ name: 'customers.accountsDetails.gifts.current', params: to.params }),
          meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all' },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.gifts.current',
              component: giftsCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.gifts.history',
              component: giftsHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all' }
            }
          ]
        },
        {
          path: 'services/:id?',
          name: 'customers.accountsDetails.services',
          component: servicesSection,
          meta: { name: 'services', userType: 'provider', serviceTypes: 'all' }
        }
      ]
    }]
  }
]
